'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMobile, iconMobileTag } from '@ni/nimble-components/dist/esm/icons/mobile';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMobile };
export { iconMobileTag };
export const NimbleIconMobile = wrap(IconMobile);